/**
 *
 * @param {*} number
 * @param {*} maxValue
 */
const addLeadingZeros = (number, maxValue) => String(number).padStart(maxValue, '0');
export default addLeadingZeros;